(function () {
  if (window.ShopifyUgcMarquee && window.ShopifyUgcMarquee.init) {
    window.ShopifyUgcMarquee.init(document);
    return;
  }

  var SELECTOR = '[data-ugc-marquee]';
  var PALETTE = ['#5B6EE8', '#FF6B6B', '#FFB347', '#3FA796', '#9B6BD6'];
  var instances = new WeakMap();

  function toBoolean(value) {
    return value === true || value === 'true';
  }

  function setVar(element, name, value) {
    if (value !== null && value !== undefined && value !== '') {
      element.style.setProperty(name, value);
    }
  }

  function iconMuted() {
    return '<svg viewBox="0 0 24 24" fill="none" focusable="false" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3z" fill="currentColor"></path><path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
  }

  function iconSound() {
    return '<svg viewBox="0 0 24 24" fill="none" focusable="false" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3z" fill="currentColor"></path><path d="M16 8a5 5 0 010 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"></path></svg>';
  }

  function createElement(tagName, className) {
    var element = document.createElement(tagName);
    if (className) {
      element.className = className;
    }
    return element;
  }

  function UgcMarquee(section) {
    this.section = section;
    this.track = section.querySelector('[data-ugc-track]');
    this.viewport = section.querySelector('.ugc-marquee__viewport');
    this.cardVideos = Array.prototype.slice.call(section.querySelectorAll('[data-ugc-track] video'));
    this.allCards = Array.prototype.slice.call(section.querySelectorAll('[data-ugc-card]'));
    this.cards = this.allCards.filter(function (card) {
      return !card.closest('[aria-hidden="true"]');
    });
    this.modal = section.querySelector('[data-ugc-modal]');
    this.dialog = section.querySelector('[data-ugc-dialog]');
    this.mediaWrap = section.querySelector('[data-ugc-modal-media]');
    this.avatar = section.querySelector('[data-ugc-avatar]');
    this.username = section.querySelector('[data-ugc-username]');
    this.caption = section.querySelector('[data-ugc-caption]');
    this.hashtags = section.querySelector('[data-ugc-hashtags]');
    this.date = section.querySelector('[data-ugc-date]');
    this.info = section.querySelector('[data-ugc-info]');
    this.closeButton = section.querySelector('[data-ugc-close]');
    this.prevButton = section.querySelector('[data-ugc-prev]');
    this.nextButton = section.querySelector('[data-ugc-next]');
    this.currentIndex = 0;
    this.lastFocused = null;
    this.observer = null;
    this.boundOnKeydown = this.onKeydown.bind(this);
    this.boundOnVisibilityChange = this.onVisibilityChange.bind(this);
    this.boundOnModalClick = this.onModalClick.bind(this);
    this.boundOnFrame = this.onFrame.bind(this);
    this.boundMeasure = this.measure.bind(this);

    this.offset = 0;
    this.halfWidth = 0;
    this.speedSeconds = parseFloat(section.dataset.scrollSpeed) || 32;
    this.dragging = false;
    this.dragMoved = false;
    this.hovered = false;
    this.inView = true;
    this.lastFrame = null;
    this.rafId = null;

    this.applySettings();
    this.bindEvents();
    this.observeVisibility();
    this.setupMarquee();
  }

  UgcMarquee.prototype.applySettings = function () {
    var dataset = this.section.dataset;

    setVar(this.section, '--ugc-background', dataset.backgroundColor);
    setVar(this.section, '--ugc-heading', dataset.headingColor);
    setVar(this.section, '--ugc-text', dataset.textColor);
    setVar(this.section, '--ugc-visible-desktop', dataset.desktopVisible);
    setVar(this.section, '--ugc-visible-mobile', dataset.mobileVisible);
    setVar(this.section, '--ugc-speed', dataset.scrollSpeed + 's');
    setVar(this.section, '--ugc-radius', dataset.cardRadius + 'px');
    setVar(this.section, '--ugc-gap', dataset.cardGap + 'px');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if (this.track) {
        this.track.classList.add('is-paused');
      }
      this.reducedMotion = true;
      this.pauseCardVideos();
    }
  };

  UgcMarquee.prototype.setupMarquee = function () {
    if (!this.track || !this.viewport) {
      return;
    }

    this.track.classList.add('is-js');
    this.measure();
    this.bindDrag();
    window.addEventListener('resize', this.boundMeasure);
    this.rafId = window.requestAnimationFrame(this.boundOnFrame);
  };

  UgcMarquee.prototype.measure = function () {
    this.halfWidth = this.track.scrollWidth / 2;
  };

  UgcMarquee.prototype.wrapOffset = function (value) {
    if (!this.halfWidth) {
      return 0;
    }
    return ((value % this.halfWidth) + this.halfWidth) % this.halfWidth;
  };

  UgcMarquee.prototype.applyOffset = function () {
    this.track.style.transform = 'translate3d(' + -this.offset + 'px, 0, 0)';
  };

  UgcMarquee.prototype.isMarqueePaused = function () {
    return (
      this.dragging ||
      this.reducedMotion ||
      !this.inView ||
      !this.halfWidth ||
      (this.hovered && toBoolean(this.section.dataset.pauseHover))
    );
  };

  UgcMarquee.prototype.onFrame = function (timestamp) {
    if (this.lastFrame !== null && !this.isMarqueePaused()) {
      var delta = Math.min(timestamp - this.lastFrame, 100) / 1000;
      var pxPerSecond = this.halfWidth / this.speedSeconds;
      this.offset = this.wrapOffset(this.offset + pxPerSecond * delta);
      this.applyOffset();
    }

    this.lastFrame = timestamp;
    this.rafId = window.requestAnimationFrame(this.boundOnFrame);
  };

  UgcMarquee.prototype.bindDrag = function () {
    var self = this;
    var viewport = this.viewport;
    var startX = 0;
    var startOffset = 0;

    viewport.addEventListener('pointerdown', function (event) {
      if (event.button > 0) {
        return;
      }
      self.dragging = true;
      self.dragMoved = false;
      startX = event.clientX;
      startOffset = self.offset;
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!self.dragging) {
        return;
      }

      var dx = event.clientX - startX;

      if (!self.dragMoved) {
        if (Math.abs(dx) <= 6) {
          return;
        }

        self.dragMoved = true;
        viewport.classList.add('is-dragging');
        if (viewport.setPointerCapture) {
          try {
            viewport.setPointerCapture(event.pointerId);
          } catch (error) {
            /* ignore */
          }
        }
      }

      self.offset = self.wrapOffset(startOffset - dx);
      self.applyOffset();
    });

    var endDrag = function () {
      self.dragging = false;
      viewport.classList.remove('is-dragging');
    };

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    viewport.addEventListener('click', function (event) {
      if (self.dragMoved) {
        event.preventDefault();
        event.stopPropagation();
        self.dragMoved = false;
      }
    }, true);

    viewport.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    viewport.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse') {
        self.hovered = true;
      }
    });

    viewport.addEventListener('pointerleave', function () {
      self.hovered = false;
    });
  };

  UgcMarquee.prototype.pauseCardVideos = function () {
    this.cardVideos.forEach(function (video) {
      video.pause();
    });
  };

  UgcMarquee.prototype.playCardVideos = function () {
    if (this.reducedMotion || !toBoolean(this.section.dataset.autoplayVideo)) {
      return;
    }

    this.cardVideos.forEach(function (video) {
      video.muted = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  };

  UgcMarquee.prototype.bindEvents = function () {
    var self = this;

    this.allCards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (!toBoolean(self.section.dataset.enablePopup)) {
          return;
        }
        self.open(Number(card.dataset.index || 0));
      });
    });

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.previous.bind(this));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.next.bind(this));
    }

    if (this.modal) {
      this.modal.addEventListener('click', this.boundOnModalClick);
    }

    document.addEventListener('keydown', this.boundOnKeydown);
    document.addEventListener('visibilitychange', this.boundOnVisibilityChange);
  };

  UgcMarquee.prototype.observeVisibility = function () {
    var self = this;

    if (!this.track || !('IntersectionObserver' in window)) {
      return;
    }

    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        self.inView = entry.isIntersecting;
        self.track.classList.toggle('is-paused', !entry.isIntersecting);

        if (!entry.isIntersecting) {
          self.pauseCurrentVideo();
          self.pauseCardVideos();
        } else {
          self.playCardVideos();

          if (self.isOpen()) {
            self.playCurrentVideo();
          }
        }
      });
    }, { threshold: 0.05 });

    this.observer.observe(this.section);
  };

  UgcMarquee.prototype.getPost = function (index) {
    var card = this.cards[index];

    if (!card) {
      return null;
    }

    return {
      type: card.dataset.mediaType || 'image',
      imageSrc: card.dataset.imageSrc || '',
      videoSrc: card.dataset.videoSrc || '',
      videoPoster: card.dataset.videoPoster || card.dataset.imageSrc || '',
      avatarSrc: card.dataset.avatarSrc || '',
      username: card.dataset.username || '',
      caption: card.dataset.caption || '',
      hashtags: card.dataset.hashtags || '',
      date: card.dataset.date || ''
    };
  };

  UgcMarquee.prototype.open = function (index) {
    if (!this.modal || !this.cards.length) {
      return;
    }

    this.currentIndex = index;
    this.lastFocused = document.activeElement;
    this.render();
    this.modal.hidden = false;
    window.requestAnimationFrame(function () {
      this.modal.classList.add('is-open');
    }.bind(this));
    document.body.classList.add('ugc-marquee-modal-open');

    if (this.closeButton) {
      this.closeButton.focus({ preventScroll: true });
    }
  };

  UgcMarquee.prototype.close = function () {
    if (!this.modal) {
      return;
    }

    this.modal.classList.remove('is-open');
    document.body.classList.remove('ugc-marquee-modal-open');
    this.clearMedia();

    window.setTimeout(function () {
      if (this.modal && !this.modal.classList.contains('is-open')) {
        this.modal.hidden = true;
      }
    }.bind(this), 250);

    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      this.lastFocused.focus({ preventScroll: true });
    }
  };

  UgcMarquee.prototype.isOpen = function () {
    return Boolean(this.modal && this.modal.classList.contains('is-open'));
  };

  UgcMarquee.prototype.clearMedia = function () {
    if (this.mediaWrap) {
      this.mediaWrap.textContent = '';
    }
  };

  UgcMarquee.prototype.render = function () {
    var post = this.getPost(this.currentIndex);

    if (!post) {
      return;
    }

    this.renderMedia(post);
    this.renderProfile(post);

    this.username.textContent = post.username;
    this.caption.textContent = post.caption;
    this.hashtags.textContent = post.hashtags;
    this.date.textContent = post.date;

    this.caption.hidden = !post.caption;
    this.hashtags.hidden = !post.hashtags;
    this.date.hidden = !post.date;

    var showInfo = toBoolean(this.section.dataset.showInfo);
    var hasInfo = Boolean(post.username || post.caption || post.hashtags || post.date || post.avatarSrc);
    var infoVisible = showInfo && hasInfo;

    if (this.info) {
      this.info.hidden = !infoVisible;
    }

    if (this.dialog) {
      this.dialog.classList.toggle('ugc-marquee__dialog--media-only', !infoVisible);
    }
  };

  UgcMarquee.prototype.renderMedia = function (post) {
    this.clearMedia();

    if (post.type === 'video' && post.videoSrc) {
      this.renderVideo(post);
      return;
    }

    if (post.imageSrc) {
      var image = createElement('img');
      image.src = post.imageSrc;
      image.alt = post.username ? post.username + ' post' : '';
      image.loading = 'lazy';
      image.decoding = 'async';
      this.mediaWrap.appendChild(image);
    }
  };

  UgcMarquee.prototype.renderVideo = function (post) {
    var video = createElement('video');
    var muteButton = createElement('button', 'ugc-marquee__mute');
    var mutedByDefault = toBoolean(this.section.dataset.videoMuted);
    var autoplay = toBoolean(this.section.dataset.autoplayVideo);

    video.src = post.videoSrc;
    video.poster = post.videoPoster;
    video.preload = 'metadata';
    video.loop = true;
    video.muted = mutedByDefault;
    video.playsInline = true;
    video.controls = !autoplay;

    if (autoplay) {
      video.autoplay = true;
    }

    muteButton.type = 'button';
    muteButton.setAttribute('aria-label', mutedByDefault ? 'Unmute video' : 'Mute video');
    muteButton.innerHTML = mutedByDefault ? iconMuted() : iconSound();
    muteButton.addEventListener('click', function () {
      video.muted = !video.muted;
      muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      muteButton.innerHTML = video.muted ? iconMuted() : iconSound();
    });

    this.mediaWrap.appendChild(video);
    this.mediaWrap.appendChild(muteButton);

    if (autoplay) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          video.controls = true;
        });
      }
    }
  };

  UgcMarquee.prototype.renderProfile = function (post) {
    var initial = post.username.replace('@', '').trim().charAt(0).toUpperCase();
    var color = PALETTE[this.currentIndex % PALETTE.length];

    this.avatar.textContent = '';
    this.avatar.style.backgroundImage = '';

    if (post.avatarSrc) {
      this.avatar.style.backgroundColor = 'transparent';
      this.avatar.style.backgroundImage = 'url("' + post.avatarSrc + '")';
      return;
    }

    this.avatar.style.backgroundColor = color;
    this.avatar.textContent = initial || '?';
  };

  UgcMarquee.prototype.next = function () {
    if (!this.cards.length) {
      return;
    }
    this.currentIndex = (this.currentIndex + 1) % this.cards.length;
    this.render();
  };

  UgcMarquee.prototype.previous = function () {
    if (!this.cards.length) {
      return;
    }
    this.currentIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length;
    this.render();
  };

  UgcMarquee.prototype.onModalClick = function (event) {
    if (event.target === this.modal) {
      this.close();
    }
  };

  UgcMarquee.prototype.onKeydown = function (event) {
    if (!this.isOpen()) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.next();
    }

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.previous();
    }

    if (event.key === 'Tab') {
      this.trapFocus(event);
    }
  };

  UgcMarquee.prototype.trapFocus = function (event) {
    var focusable = Array.prototype.slice.call(this.modal.querySelectorAll('button, video[controls], [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      return !element.disabled && element.offsetParent !== null;
    });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (!first || !last) {
      return;
    }

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  UgcMarquee.prototype.onVisibilityChange = function () {
    if (document.hidden) {
      this.pauseCurrentVideo();
      this.pauseCardVideos();
    } else {
      this.playCardVideos();

      if (this.isOpen()) {
        this.playCurrentVideo();
      }
    }
  };

  UgcMarquee.prototype.pauseCurrentVideo = function () {
    var video = this.mediaWrap ? this.mediaWrap.querySelector('video') : null;
    if (video) {
      video.pause();
    }
  };

  UgcMarquee.prototype.playCurrentVideo = function () {
    var video = this.mediaWrap ? this.mediaWrap.querySelector('video') : null;
    if (video && toBoolean(this.section.dataset.autoplayVideo)) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  };

  UgcMarquee.prototype.destroy = function () {
    document.removeEventListener('keydown', this.boundOnKeydown);
    document.removeEventListener('visibilitychange', this.boundOnVisibilityChange);
    window.removeEventListener('resize', this.boundMeasure);

    if (this.rafId !== null) {
      window.cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    if (this.modal) {
      this.modal.removeEventListener('click', this.boundOnModalClick);
    }

    if (this.observer) {
      this.observer.disconnect();
    }

    this.close();
  };

  function init(root) {
    var scope = root || document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));

    if (scope.matches && scope.matches(SELECTOR)) {
      sections.push(scope);
    }

    sections.forEach(function (section) {
      if (!instances.has(section)) {
        instances.set(section, new UgcMarquee(section));
      }
    });
  }

  function destroy(root) {
    var scope = root || document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll(SELECTOR));

    if (scope.matches && scope.matches(SELECTOR)) {
      sections.push(scope);
    }

    sections.forEach(function (section) {
      var instance = instances.get(section);

      if (instance) {
        instance.destroy();
        instances.delete(section);
      }
    });
  }

  window.ShopifyUgcMarquee = {
    init: init,
    destroy: destroy
  };

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
